import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

// @mui
import { Stack, Typography } from '@mui/material';
// components
import ConfirmModal from 'components/ConfirmModal';

import { ReactComponent as PowerIcon } from 'assets/images/svg/power.svg';

// ----------------------------------------------------------------------

export default function LogOutButton({ onLogOut }) {
  const { t } = useTranslation();

  const confirmQuitRef = useRef(null);
  const openConfirm = () => {
    confirmQuitRef.current.handleOpen();
  };
  return (<>
    <ConfirmModal ref={confirmQuitRef} onAccept={onLogOut} title={t("popup.titles.confirmation")} message={t("popup.logOutConfirmation")}> </ConfirmModal>
    <Stack direction="row" color="primairy"
      alignItems="center"
      justifyContent="space-between"
      onClick={openConfirm}
      sx={{
        backgroundColor: 'white',
        px: 4,
        py: 1,
        '&:hover': {
          cursor: 'pointer',
        }
      }}>
      <Typography color="primary" variant="h6">
        {t("buttons.logOut")}
      </Typography>
      <PowerIcon
        className="primary_color"
        height={35}
        width={35}
      />
    </Stack>
  </>

  );
}

// ----------------------------------------------------------------------
